import React from 'react';
import PropTypes from 'prop-types';
import Chip from '@mui/material/Chip';
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';

// A clip to play: a neutral outlined chip like the date presets, so it never outweighs the scores.
const clipChipSx = {
  m: 0,
  borderRadius: '5px',
  borderColor: 'vpColors.greyLight',
  color: 'text.primary',
  '& .MuiChip-icon': { color: 'primary.main' },
  '&:hover': { bgcolor: 'vpColors.greyLighter' }
};

export const VpClipChip = ({ label, ariaLabel, onClick }) => (
  <Chip
    size="small"
    variant="outlined"
    clickable
    onClick={onClick}
    aria-label={ariaLabel}
    icon={<PlayArrowRoundedIcon fontSize="small" />}
    label={label}
    sx={clipChipSx}
  />
);

VpClipChip.propTypes = { label: PropTypes.string.isRequired, ariaLabel: PropTypes.string.isRequired, onClick: PropTypes.func.isRequired };



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpClipChip/VpClipChip.jsx